module.exports = __webpack_public_path__ + "static/media/MEINPES_MENU-normal.46e88016.png";